import { SERVER_ERROR } from './';

export default response => ({ type: SERVER_ERROR, payload: response });
